// Конфігурація шляхів до зображень
// Цей файл містить всі шляхи до зображень, які використовуються у портфоліо

export interface ImageConfig {
  src: string;
  alt: string;
}

export interface WorkSection {
  id: string;
  images: ImageConfig[];
}

// Зображення для секції About
export const aboutImages: ImageConfig[] = [
  { src: '/images/about/about.jpg', alt: 'Alina Poloneyeva' },
  { src: '/images/about/about_1.jpg', alt: 'Alina Poloneyeva' }
];

// Зображення для секції Work
export const workSections: WorkSection[] = [
  {
    id: 'content-creation',
    images: [
      { src: '/images/publications/publications_1.PNG', alt: 'Content Creation 1' },
      { src: '/images/publications/publications_2.PNG', alt: 'Content Creation 2' }
    ]
  },
  {
    id: 'modeling',
    images: [
      { src: '/images/modeling/modeling_1.jpg', alt: 'Modeling 1' },
      { src: '/images/modeling/modeling_2.jpg', alt: 'Modeling 2' },
      { src: '/images/modeling/modeling_3.jpg', alt: 'Modeling 3' },
      { src: '/images/modeling/modeling_4.jpg', alt: 'Modeling 4' },
      { src: '/images/modeling/modeling_5.jpg', alt: 'Modeling 5' },
      { src: '/images/modeling/modeling_6.jpg', alt: 'Modeling 6' },
      { src: '/images/modeling/modeling_7.jpg', alt: 'Modeling 7' },
      { src: '/images/modeling/modeling_8.jpg', alt: 'Modeling 8' },
      { src: '/images/modeling/modeling_9.jpg', alt: 'Modeling 9' },
      { src: '/images/modeling/modeling_10.jpg', alt: 'Modeling 10' },
      { src: '/images/modeling/modeling_11.jpg', alt: 'Modeling 11' },
      { src: '/images/modeling/modeling_12.jpg', alt: 'Modeling 12' },
      { src: '/images/modeling/modeling_13.jpg', alt: 'Modeling 13' },
      { src: '/images/modeling/modeling_14.jpg', alt: 'Modeling 14' },
      { src: '/images/modeling/modeling_15.jpg', alt: 'Modeling 15' },
      { src: '/images/modeling/modeling_16.jpg', alt: 'Modeling 16' },
      { src: '/images/modeling/modeling_17.jpg', alt: 'Modeling 17' },
      { src: '/images/modeling/modeling_18.jpg', alt: 'Modeling 18' },
      // { src: '/images/modeling/modeling_19.jpg', alt: 'Modeling 19' },
      // { src: '/images/modeling/modeling_20.jpg', alt: 'Modeling 20' },
      // { src: '/images/modeling/modeling_21.jpg', alt: 'Modeling 21' },
      // { src: '/images/modeling/modeling_22.jpg', alt: 'Modeling 22' },
      // { src: '/images/modeling/modeling_23.jpg', alt: 'Modeling 23' },
      // { src: '/images/modeling/modeling_24.jpg', alt: 'Modeling 24' },
      // { src: '/images/modeling/modeling_25.jpg', alt: 'Modeling 25' },
      // { src: '/images/modeling/modeling_26.jpg', alt: 'Modeling 26' },
    ]
  },
  {
    id: 'publications',
    images: [
      { src: '/images/publications/publications_5.JPEG', alt: 'Publications 1' },
      { src: '/images/publications/publications_6_1.PNG', alt: 'Publications 2' },
      { src: '/images/publications/publications_6_2.PNG', alt: 'Publications 3' },
      { src: '/images/publications/publications_7.PNG', alt: 'Publications 4' },
      { src: '/images/publications/publications_8.JPG', alt: 'Publications 5' },
      { src: '/images/publications/publications_9.PNG', alt: 'Publications 6' },
      { src: '/images/publications/publications_10.PNG', alt: 'Publications 7' },
      { src: '/images/publications/publications_11.PNG', alt: 'Publications 8' },
      { src: '/images/publications/publications_12.PNG', alt: 'Publications 9' },
      { src: '/images/publications/publications_13_1.PNG', alt: 'Publications 10' },
      { src: '/images/publications/publications_13_2.PNG', alt: 'Publications 11' },
      { src: '/images/publications/publications_14.JPG', alt: 'Publications 12' }
    ]
  }
];
